import { Card, Center, Stack, Title } from '@buildex/ui';
import { TenantLogo } from '@buildex/ui';
import { useTranslation } from 'react-i18next';
import { LoginForm } from '@/features/login/LoginForm';

export function LoginPage() {
  const { t } = useTranslation();

  return (
    <Center h="100vh">
      <Card withBorder w={380} padding="xl">
        <Stack gap="md">
          <Center>
            <TenantLogo />
          </Center>
          <Title order={3} ta="center">
            {t('login.title')}
          </Title>
          <LoginForm />
        </Stack>
      </Card>
    </Center>
  );
}
